import { useEffect, useState } from 'react';

import { AccessAlarm } from '@mui/icons-material';
import { Button, Dialog, Typography } from '@mui/material';

import { CircularProgressWithLabel } from 'components/CircularProgressWithLabel';
import { colors } from 'config/theme';

import { AlertWrapper, HR, ButtonWrapper, Text } from './styledComponents';

interface TimeoutModalProps {
  signOut: () => void;
  setStillActive: () => void;
  timeout: number;
}

export const TimeoutModal: React.FC<TimeoutModalProps> = ({
  signOut,
  setStillActive,
  timeout,
}) => {
  const [counter, setCounter] = useState(timeout);

  useEffect(() => {
    const timer = setTimeout(() => setCounter(counter - 1), 1000);

    if (counter === 0) {
      signOut();
    }
    return () => clearTimeout(timer);
  }, [counter, setCounter, signOut]);

  return (
    <Dialog open>
      <AlertWrapper>
        <AccessAlarm
          style={{ color: colors.uswds.redCool50, fontSize: '70px' }}
        />
        <Typography sx={{ mb: 2, mt: 2 }} variant='h4'>
          You will be logged out because of inactivity
        </Typography>
        <Text>
          {' '}
          If you'd like to stay logged in, please click the button below.
        </Text>
        <CircularProgressWithLabel
          startCount={timeout}
          currentCount={counter}
        />
        <HR />
        <ButtonWrapper>
          <Button sx={{ m: 1 }} variant='contained' onClick={setStillActive}>
            Stay Logged In
          </Button>
          <Button sx={{ m: 1 }} variant='outlined' onClick={signOut}>
            Log Out
          </Button>
        </ButtonWrapper>
      </AlertWrapper>
    </Dialog>
  );
};
